export default {"src":"/_next/static/media/question-circle-fill.546e92c0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};